import React, { useContext, useMemo, useState } from 'react';
import ModalComponent from './NewModal';
import { useEventListener } from '@td-client-frontend/common';

const ModalContext = React.createContext<{
  showModal: (content: React.ReactNode) => void;
  hideModal: () => void;
  refreshModalWith: (content: React.ReactNode) => void;
}>({
  showModal: () => {},
  hideModal: () => {},
  refreshModalWith: () => {}
});

// Wrap the app with this
export function Modal({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = useState<any>(null);
  const [open, setOpen] = useState(false);

  const openModal = (modalConfig: any) => {
    setConfig((prevState: any) => ({ ...prevState, ...modalConfig }));
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setConfig(null);
  };

  const context = useMemo(
    () => ({
      showModal: openModal,
      refreshModalWith: openModal,
      hideModal: () => {
        const { onClose } = config || {};
        if (onClose) {
          onClose();
        }
        closeModal();
      }
    }),
    [config]
  );

  // @ts-ignore
  useEventListener('keydown', ({ keyCode, target }) => {
    // TODO unhackify
    // @ts-ignore
    if (keyCode === 27 && typeof target.className === 'string' && !target?.className?.includes('react-datepicker')) {
      context.hideModal();
    }
  });

  return (
    <ModalContext.Provider value={context}>
      <ModalComponent {...config} onClose={closeModal} isOpen={open}>
        {config?.content}
      </ModalComponent>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('The component this hook must be a descendant of the ModalProvider');
  }
  return context;
}
